import {
  IUseChatHandlers,
  ThirdPartyChatProvider,
  UseInitChatProviderType,
} from '@core/chat/interfaces';
import { env } from 'env';

const thirdPartyProvider =
  env.REACT_APP_FEATURE_THIRD_PARTY_CHAT_PROVIDER ||
  ThirdPartyChatProvider.StreamChat;

let useInitChatProvider: UseInitChatProviderType;
if (thirdPartyProvider === ThirdPartyChatProvider.StreamChat) {
  useInitChatProvider = require('@core/chat/StreamChat/hooks').default;
} else {
  throw new Error(`Unknown library: ${thirdPartyProvider}`);
}

const useChatHandlers = ({
  currentEvent,
  streamChatToken,
}: IUseChatHandlers) => {
  useInitChatProvider({ currentEvent, streamChatToken });
};

export default useChatHandlers;
